import { Component, Injector, TemplateRef, ViewChild } from '@angular/core';

import { Observable, of } from 'rxjs';
import { mergeMap } from 'rxjs/operators';

import { JournodexQuickSearchEntityApiModel } from '../../../../api/journodex/model/journodex-quick-search-entity-api.model';
import { EntityType } from '../../../../api/targeting/enum/entity.type.enum';
import { ButtonTypesEnum } from '../../enums/button-types.enum';
import { JournodexApiService } from '../../../../api/journodex/journodex.api.service';
import { LocalizationService } from '../../../../Core/Localization/services/localization.service';
import { CoreDialogService } from '../../../../Core/Dialogs/services/dialog.service';
import { ResearchRequestDialogComponent } from '../../../Dialogs/components/ResearchRequestDialog/research-request-dialog.component';
import { EntityTypeDefaultImageEnum } from '../../../Misc/enums/entity-type-default-image.enum';

@Component({
    selector: 'agpr-journodex-quick-search',
    templateUrl: './journodex-quick-search.component.html',
    styleUrls: ['./journodex-quick-search.component.scss'],
    standalone: false
})
export class JournodexQuickSearchComponent {
    @ViewChild('overlayTemplate') overlayTemplate: TemplateRef<any>;

    labelField = 'entityName';
    search: string = '';
    suggestions: any[];

    buttonTypesEnum = ButtonTypesEnum;
    imageDefault = EntityTypeDefaultImageEnum;

    constructor(
        public journodexApiService: JournodexApiService,
        public injector: Injector,
        public localizationService: LocalizationService,
        public coreDialogService: CoreDialogService
    ) {
    }

    performAutocomplete(searchString: any): Observable<any> {
        this.search = searchString;

        return this.journodexApiService.contactOutletQuickSearch(this.search).pipe(mergeMap((results: any) => {
            const contact = {
                label: 'Common.journodexQuickSearch.contacts',
                value: EntityType.CONTACT,
                items: []
            };

            const outlet = {
                label: 'Common.journodexQuickSearch.outlets',
                value: EntityType.OUTLET,
                items: []
            };

            for (const result of results) {
                if (result.entityType === EntityType.CONTACT) {
                    contact.items.push(result);
                }

                if (result.entityType === EntityType.OUTLET) {
                    outlet.items.push(result);
                }
            }

            if (contact.items.length > 3) {
                contact.items.splice(3);
            }

            if (outlet.items.length > 3) {
                outlet.items.splice(3);
            }

            this.suggestions =  [contact, outlet];

            return of(this.suggestions);
        }));
    }

    navigateToSelectedProfile(entity: JournodexQuickSearchEntityApiModel) {
        if (entity.entityType === EntityType.OUTLET) {
            window.location.href = `Discover/profile/outlet/${entity.id}`;
        }

        if (entity.entityType === EntityType.CONTACT) {
            window.location.href = `Discover/profile/contact/${entity.id}`;
        }
    }

    viewAllInGroup(group: any): void {
        if (group.value === EntityType.OUTLET.toString()) {
            window.location.href = `Discover/targetingsearches/search/results?name=${this.search}&type=${EntityType.OUTLET}`;
        }

        if (group.value === EntityType.CONTACT.toString()) {
            window.location.href = `Discover/targetingsearches/search/results?name=${this.search}&type=${EntityType.CONTACT}`;
        }
    }

    openResearchRequestDialog(event: any) {
        this.coreDialogService.open(ResearchRequestDialogComponent);
    }
}
